var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaceBackground = function SvgFaceBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 202 295"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    d: "M.863 37.5c12.637-27 13.091-36.273 75-36.273s111.955 55.227 111.955 123.409c0 21.955-5.318 42.682-14.318 60.682-15.273 29.591-22.5 62.591-22.5 95.864V294H.863v-12.818C2.5 247.5 4.363 258 .863 255"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    d: "M134.636 147.682s66.818-.137 66.818-29.591c0-12.682-15.272-14.864-15.272-14.864"
  })));
};
export default SvgFaceBackground;